var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcOptions = function SvgIcOptions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.375 11.938a.562.562 0 1 0-1.125 0 .562.562 0 0 0 1.125 0ZM12.375 4.938a.562.562 0 1 0-1.125 0 .562.562 0 0 0 1.125 0ZM12.375 18.938a.562.562 0 1 0-1.125 0 .562.562 0 0 0 1.125 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.375 11.938a.562.562 0 1 0-1.125 0 .562.562 0 0 0 1.125 0ZM12.375 4.938a.562.562 0 1 0-1.125 0 .562.562 0 0 0 1.125 0ZM12.375 18.938a.562.562 0 1 0-1.125 0 .562.562 0 0 0 1.125 0Z"
  })));
};
export default SvgIcOptions;